import React, { memo } from "react";
import { Typography } from "@mui/material";
import Choices from "../../Choices";
import ReusableAccordian from "../../ReusableAccordion";
import { automation } from "./defaults";
import { RowLayout } from "../../../util/accordianStyles";
import LearnMore from "../../LearnMore";
import useAutomationSelector from "./useAutomationSelector";

function AutomationAccordian() {
  const { checkMark, variant, handleClick } = useAutomationSelector();

  return (
    <ReusableAccordian
      accordionName="automation"
      heading="Automation"
      secondaryHeading="Select Automation Choice"
      colOrRow="col"
    >
      <Typography style={{ fontWeight: "bold" }} variant="subtitle2">
        With Automation You Can Bring Your Doors To Life With Ease
      </Typography>
      <Typography variant="caption">
        *Automation System kit & install, By Others*
      </Typography>
      <Typography variant="caption">
        **Does not include installation fees**
      </Typography>

      <RowLayout style={{ justifyContent: "space-around", width: "30%" }}>
        <div onClick={() => handleClick(automation.label)}>
          <Choices
            label={automation.label}
            variant={variant(automation.label)}
            checkMark={checkMark(automation.label)}
          />
        </div>

        <LearnMore href="https://www.agmillworks.com/about_automation" />
      </RowLayout>
    </ReusableAccordian>
  );
}

export default memo(AutomationAccordian);
